import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import translations from '../utils/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('sc_lang') || 'en');

  useEffect(() => {
    // Auto-detect: check browser language for Arabic on first visit
    const saved = localStorage.getItem('sc_lang');
    if (!saved) {
      const browserLang = navigator.language || '';
      if (browserLang.startsWith('ar')) {
        setLang('ar');
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('sc_lang', lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);

  // translations is a static module-level import, lang is the only reactive dependency
  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.en?.[key] || key;
  }, [lang]);

  const isRTL = lang === 'ar';

  const value = useMemo(() => ({ lang, setLang, t, isRTL }), [lang, t, isRTL]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
